import http from "./http-service"

export default class MessageService {

  static getUsers() {
    return http.get("messages/users")
  }

  static getGroups() {
    return http.get("messages/groups")
  }

  static getSenders() {
    return http.get("messages/senders")
  }

  static create(data) {
    return http.post("messages/create", data)
  }

  static find(data) {
    return http.post("messages/find", data)
  }

  static findByQuotation(id) {
    return http.post(`messages/find-by-quotation/${id}`).then((response) => response.messages)
  }
  
  static setDisplayed(messageId) {
    return http.put("messages/set-displayed", { messageId })
  }

  static archive(messageId) {
    return http.put("messages/archive", { messageId })
  }

  static remove(messageId) {
    return http.delete("messages/remove", { messageId })
  }
}